import * as React from 'react';

import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { FilteringListBox } from '../../common/react/components/FilteringListBox';

export class TypeaheadFilterPanel<T> extends React.Component<TypeaheadFilterPanel.Props<T>, any> {

  static displayName = 'TypeaheadFilterPanel';

  static element = React.createFactory(TypeaheadFilterPanel);

  public render() {

    const menuPanelStyle = {
      boxSizing: 'border-box',
      height: 308,    // Chosen to show 10 rows
      backgroundColor: CommonStyles.Colors.White,
      borderWidth: CommonStyles.Sizes.LineWidth,
      borderColor: CommonStyles.Colors.BorderColor,
      borderStyle: 'solid'
    };

    return React.createElement('div', { style: menuPanelStyle },
      FilteringListBox.element({
        itemStore: this.props.itemStore,
        searchBoxPlaceholder: Messages.search(),
        matchPrefixesOnly: this.props.matchPrefixesOnly,
        itemSelected: () => this.props.itemSelected(),
        style: CommonStyles.Helpers.Edges(CommonStyles.Sizes.SmallSpace)
      })
    );
  }

}

export module TypeaheadFilterPanel {

  export interface Props<T> {
    itemStore: FilteringListBox.ItemStore<FilteringListBox.Item<T>>;
    matchPrefixesOnly: boolean;
    itemSelected: () => void;
  }

}
